<template>
  <div class="assignee-info col-md-12 flex mt-4">
    <div class="col-md-3 flex flex-align-c">
      <div class="flex flex-column">
        <span class="assignee-title">Claim created date</span>
        <span class="assignee-content">{{ claimById.date }}</span>
      </div>
    </div>
    <div class="col-md-3 flex flex-align-c">
      <div class="flex flex-column">
        <span class="assignee-title">Claim created by</span>
        <span class="assignee-content">{{ claimById.created_by.username }}</span>
      </div>
    </div>
    <div class="col-md-6 flex assigned-to flex-align-c flex-justify-end">
      <div class="flex flex-column">
        <span class="assignee-title" />
        <div class="select" v-if="$_can('claims.assign')">
          <label class="assignee-title pl-3">Assigned to</label>
          <simple-select
            v-if="claimById.cluster_user"
            class="assignee-content"
            :placeholder="claimById.cluster_user.username"
            v-model="claim.cluster_user_id"
            :options="claimsUsers"
            label="username"
            @input="claimUpdate"
          />
          <simple-select
            v-else
            class="assignee-content"
            placeholder="Unassigned"
            v-model="claim.cluster_user_id"
            :options="claimsUsers"
            label="username"
            @input="claimUpdate"
          />
        </div>
        <div class="flex flex-column" v-else>
          <label class="assignee-title no-permission">Assigned to</label>
          <span v-if="claimById.cluster_user">{{ claimById.cluster_user.username }}</span>
          <span v-else>-</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import axios from 'axios';

export default {
  name: 'ClaimAssigneInfo',
  props: {
    claimById: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      claim: {
        cluster_user_id: null,
      },
    };
  },
  computed: {
    ...mapState({
      claimsUsers: state => state.claims.claimsUsers.data,
    }),
  },
  created() {
    this.getClaimsUsers();
  },
  methods: {
    ...mapActions(['getClaimsUsers']),
    customLabel(option) {
      return (
        `${option.first_name === undefined ? '' : option.first_name}` +
        ` ${option.last_name === undefined ? '' : option.last_name}`
      );
    },
    claimUpdate() {
      axios
        .put(`/claims/${this.$route.params.id}`, this.claim)
        .then(() => {
          toastr.success('Claim updated successfully');
          this.$emit('update');
        })
        .catch(err => {
          toastr.error(err);
        });
    },
  },
};
</script>

<style scoped>
.assignee-info {
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);
  min-height: 68px;
}
.assignee-content {
  color: #4c5669;
  font-family: Roboto;
  font-size: 16px;
  line-height: 20px;
}
.assignee-title {
  opacity: 0.7;
  color: #808d98;
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
}
.select:hover {
  background: #f4f5f7;
}
.no-permission {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimAssigneInfo.vue